<template>
    <div class="historique">
        <v-container class="pa-1">
            <v-row dense>
                <v-col cols="12" v-for="histo in historique" :key="histo.id">
                    <v-card tile> 
                        <v-card-title class="headline">
                           <h5>{{histo.action}}</h5>
                        </v-card-title>
                        <v-card-text class="content">
                            <p v-if='histo.commentaire'>{{histo.commentaire}}</p>
                            <p class="date"><i class="mdi mdi-clock-outline"></i> {{histo.date_ajout}}</p>
                            <p v-if='histo.realisateur'><i class="mdi mdi-account"></i>{{histo.realisateur}}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="!historique.length">
                    <p>Pas d'historique disponible pour cet utilisateur</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    props:['code', 'lead'],  
    data() {
        return {
            historique: [],
        }
    },
    created() {
        this.historique = this.lead.historiques
    },
}
</script>
<style lang="scss">
    .historique {
        h5 {
            font-size:0.7em;
        }
        .content{
            p {
                margin:0;
                color:black;
                font-size:1em;
            }
        }
    }
</style>